import {createContext, useContext} from 'react';
import {ICartItem, IRequiredProduct, IRestaurant, IRestaurantDistancePriceResponse} from 'types';

import {ColaPromoType} from '../../../store/types';

export interface ICartContext {
  cartItems: ICartItem[];
  dynamicDeliveryPrice: IRestaurantDistancePriceResponse;
  cartProvider?: IRestaurant;
  requiredProducts: IRequiredProduct[];
  cartItemsPrice: number;
  restToFreeDelivery: number;
  deliveryDetails?: {
    deliveryAmount: number;
    remainingAmount: number;
  };
  timestamp: Date;

  addProvider: (provider: IRestaurant) => void;
  addProductToCart: (product: ICartItem, crossSelling?: ICartItem[]) => void;
  editCartItem: (cartItem: ICartItem) => void;
  clearCart: (withoutNotification?: boolean) => void;
  deleteProduct: (cartItemId: string) => void;
  changeCartItemQuantity: (cartItemId: string, quantity: number) => void;
  updateTimestamp: () => void;
  refetchActiveOrders: () => void;
  setCartItems: (cartItems: ICartItem[]) => void;
  sideCartOpen: boolean;
  setSideCartOpen: (isOpen: boolean) => void;
  colaPromo?: ColaPromoType;
  isColaFreeDelivery?: boolean;
  resetDeliveryPrice: () => void;
}

export const CartContext = createContext<ICartContext>({
  cartItems: [],
  cartItemsPrice: 0,
  restToFreeDelivery: 0,
  cartProvider: undefined,
  requiredProducts: [],
  dynamicDeliveryPrice: {
    surcharge: 0,
    surcharge_for_out_area: 0,
    distance_to_client: 0,
  },
  timestamp: new Date(),
  colaPromo: {
    cola_promo_active: false,
    cola_promo_threshold: 0,
  },

  addProvider: () => {},
  addProductToCart: () => {},
  editCartItem: () => {},
  clearCart: () => {},
  deleteProduct: () => {},
  changeCartItemQuantity: () => {},
  updateTimestamp: () => {},
  refetchActiveOrders: () => {},
  setCartItems: () => {},

  sideCartOpen: false,
  setSideCartOpen: () => {},
  resetDeliveryPrice: () => {},
});

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCartContext must be used inside a `CartProvider`');
  return context;
};
